module.exports = __webpack_public_path__ + "img/sign-up-result-group_guide_steps.914726f2.png";